module.exports={
    "over_size_message":"Obrázek, který jste nahráli, má více než 10MB. Váš soubor pro nahrání zkomprimujeme. Pro pokračování v nahrávání klikněte na „Potvrdit“.",
    "file_type_error":"Soubor, který jste nahráli, není obrázek! Zkuste nahrát znovu.",
    "upload_error":"Chyba nahrávání! (Kód chyby: 2000) Zkuste to znovu.",
    "watermark_remove_over_size":"Obrázek, který jste nahráli, má více než 5MB. Doporučujeme používat náš bezplatný online kompresor obrázků. Kliknutím <a class=\"jump-link\" href=\"https://www.tipard.com/cs/image-compressor-online/\">získáte další informace</a>",
    "watermark_remove_file_type_error":"Soubor, který jste nahráli, není obrázek, nahrajte jej prosím znovu.",
    "watermark_remove_image_type_error":"Formát obrázku není podporován. Podporujeme pouze JPG, JPEG, PNG a BMP.",
    "watermark_remove_upload_error":"Chyba rozpoznání (kód chyby: 2001), zkuste to prosím znovu...",
    "watermark_remove_processing":"Zpracování obrázku...",
    "watermark_remove_not_save":"Oblast, kterou jste vybrali, nebude zachována. Opravdu to chcete oříznout?",
    "watermark_remove_back_home":"Aktuální stav nebude uložen. Opravdu se chcete vrátit na Domov stránku?",
    "watermark_remove_new_image":"Aktuální stav nebude uložen. Opravdu chcete vybrat nový obrázek?",
    "watermark_select":"Vybrat",
    "watermark_select_area":"Před kliknutím na Odstranit vyberte oblast vodoznaku, kterou chcete vymazat.",
    "watermark_beyond_4k":"Vybraný obrázek překračuje rozlišení 4K. Litujeme, v současné době jej nemůžeme zpracovat",
    "watermark_beyond_pixel_1":"Vybrané rozlišení obrázku přesahuje <span>%spx</span><span>&times;%spx</span>. Nelze zpracovat, vyberte prosím znovu.",
    "watermark_beyond_pixel_2":"Návštěvníci mohou zpracovávat pouze <span>%s</span> obrázky s rozlišením vyšším než <span>%spx</span>x<span>%spx</span>, přihlaste se prosím a pokračujte v používání.",
    "watermark_beyond_size_1":"Vybraná velikost obrázku přesahuje <span>%sMB</span>. Nelze zpracovat, vyberte prosím znovu.",
    "watermark_beyond_size_2":"Vybraná velikost obrázku přesahuje <span>%sMB</span>, ale návštěvníci mohou zpracovat pouze obrázky menší než <span>%sMB</span>. Přihlaste se a pokračujte v používání.",
    "no_user_down":"Návštěvníci si mohou stáhnout pouze obrázky <span>%s</span> v původní kvalitě. Přihlaste se prosím a pokračujte ve stahování. Můžete také uchovávat 7denní historii po přihlášení. Pokračujte ve stahování obrázků, které jsou <span>%spx</span> široké nebo vysoké.",
    "no_down_rights":"Nelze stáhnout obrázky HD v původní kvalitě, upgradujte prosím svůj plán! Můžete také pokračovat ve stahování obrázků nízké kvality pomocí <span>%spx</span>.",
    "error_40001":"Chyba: 40001. Kontaktujte nás",
    "error_40099":"Chyba: 40099. Kontaktujte nás",
    "down_btn":"Stahování se připravuje, počkejte prosím chvíli...",
    "noRemove_down_btn":"Pro odstranění vodoznaků jste nic neudělali. Vyberte vodoznak, který chcete odstranit, a klikněte na tlačítko Odebrat. Poté si můžete stáhnout svůj obrázek.",
    "history_open":"Otevírá se upravený obrázek, chvíli počkejte...",
    "maskRightsMonitor_info":"Stránka pro upgrade výhod byla otevřena na nové kartě a váš plán bude po upgradu automaticky synchronizován.",
    "maskLoginMonitor_info":"Vstupní stránka byla otevřena, dokončete na ní přihlášení. Po úspěšném přihlášení nebo registraci bude tato stránka automaticky synchronizována, prosím nezavírejte ji.",
    "photo_rights_info":"V současné době lze stáhnout <span><i class=\"num\">2</i> HD obrázky</span> v původní kvalitě. <a href=\"https://account.tipard.com\" target=\"_blank\">Zobrazit podrobnosti>></a>",
    "rights_original":"Chcete-li zapnout nastavení \"Použít funkci Image Enhancer ke snížení ztráty kvality\", musíte upgradovat svůj účet!",
    "Brush":"Štětec",
    "Lasso":"Laso",
    "Polygonal":"Polygonální",
    "Eraser":"Guma",
    "Free":"Volný, uvolnit",
    "More":"Více:",
    "Select":"Vybrat",
    "Remove":"Odstranit",
    "BrushSize":"Velikost štětce:",
    "AspectRatio":"Poměr stran:",
    "Upload":"Nová fotka",
    "History":"Dějiny",
    "Login":"Přihlásit se",
    "MyAccount":"Můj účet",
    "Logout":"Odhlásit se",
    "Usinghelp":"Pomocí nápovědy >>",
    "Enhancer":"Ke snížení ztráty kvality použijte funkci Image Enhancer",
    "Download":"Stažení",
    "Guide":"Průvodce",
    "Polygonal1":"Polygonální",
    "Polygonal_info":"Kliknutím levým tlačítkem myši identifikujete bod najednou.",
    "Lasso1":"Laso:",
    "Lasso_info":"Dlouhým stisknutím levého tlačítka myši lasote oblast vodoznaku.",
    "Brush1":"Štětec:",
    "Brush_info":"Dlouhým stisknutím levého tlačítka myši vyberte přesně.",
    "Eraser1":"Guma:",
    "Eraser_info":"Vymažte nepotřebné části z vybrané oblasti.",
    "Click":"Klikněte",
    "the":"a",
    "click_info":"tlačítko pro zahájení mazání nechtěného vodoznaku.",
    "PleaseUploadImages":"Nahrajte obrázky.",
    "CropInfo":"Po odstranění vodoznaku můžete kliknout na tlačítko Oříznout a obrázek před uložením oříznout, nebo kliknutím na tlačítko Stáhnout uložit přímo aktuální obrázek.",
    "Crop":"Oříznutí",
    "Back":"Zadní",
    "DownloadCropped":"Automaticky přeloženo z angličtiny",
    "Cancel":"zrušení",
    "FreeWatermarkRemover":"Zdarma odstraňovač vodoznaku",
    "Processing":"Zpracovává se...",
    "NewImage":"Nový vzhled",
    "Retry":"Zkuste to znovu",
    "Yes":"Ano",
    "No":"Ne",
    "FailureFeedback":"Zpětná vazba při selhání",
    "removeTip":"Po výběru oblasti vodoznaku kliknutím na tlačítko Odebrat vodoznak smažte.",
    "rightDown":"Stáhnout obrázky nízké kvality",
    "history_will":"Vyprší po",
    "Expired":"(platnost vypršela)",
	"uploadImage":"Přidat obrázek",
    "uploadImageInfo":"Nebo sem pusťte soubor obrázku a odstraňte vodoznak!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Neomezený",
    "watermark_beyond_pixel_3":"Vybraný obrázek překračuje <span>%s&times;%s rozlišení</span>, nejprve prosím upgradujte svůj plán.",
    "watermark_beyond_size_3":"Vybraný obrázek přesahuje <span>%sMB</span>, nejprve prosím upgradujte svůj plán.",
    "no_user_login":"Noví uživatelé, kteří se přihlásí, mohou získat DVĚ výhody stahování originálních obrázků v HD.<span class=\"loginMaskbtn\">Přihlásit se okamžitě>></span>",
    "Upgrade":"Vylepšit",
    "Loading":"Načítání…",
    "SelectAll":"Vybrat vše",
    "Open":"OTEVŘENO",
    "Delete":"Vymazat",
    "Clear":"Vymazat neplatné",
    "noHistory":"Žádná historie",
    "Close":"Zavřít",
    "buyUserInfo":"gratuluji! Úspěšně jste upgradovali. Vraťte se prosím na domovskou stránku a použijte tento produkt.",
    "buyNoUserInfo":"Gratulujeme! Úspěšně jste upgradovali. Výhody byly vázány na e-mailovou adresu, kterou jste zanechali při upgradu. Pro <span class=\"loginMaskbtn\">přihlášení pro využívání výhod</span> použijte prosím zaregistrovaný účet nebo propojený s e-mailovou adresou. Pokud jste se nezaregistrovali nebo nepropojili účet s e-mailovou adresou, <span class=\"registerMaskbtn\">použijte e-mailovou adresu k registraci účtu</span> nebo propojte další účty s tímto e-mailem poštovní adresu pro využívání výhod.",
    "GetStarted":"Začít",
    "AccessTo":"Přístup k:",
    "imagesOfwatermarkremoval":"obrázky odstranění vodoznaku",
    "upTo":"Až do",
    "perImage":"za obrázek",
    "Support":"Podpěra, podpora",
    "resolution":"rozlišení",
    "PrepaidPackage":"Předplacený balíček",
    "PayasYouGo":"Plaťte, jak jdete",
    "TaxIncl":"Včetně daně.",
    "Checkout":"Překontrolovat",
    "imagesDay":"obrázky/den",
    "imagesMonthly":"obrázky/měsíčně",
    "image":"obraz",
    "images":"snímky",
    "imageSize":"velikost obrázku",
    "buyInfo1":"Integrace <span>vylepšováků</span> třetích stran",
    "buyInfo2":"Historie úprav je platná 7 dní",
    "buyInfo3":"Přednostní zpracování",
    "buyInfo4":"Zákaznická podpora 7x24",
    "buyInfo5":"Platnost vypršela po 24 hodinách",
    "buyInfo6":"Žádné předplatné. Žádné automatické obnovení!",
    "buyInfo7":"K dispozici pro použití kdykoli navždy",
    "dayPlan":"1-denní plán",
    "Lifetime":"Život",
    'note':"<span>Poznámka</span>: Vezměte prosím na vědomí, že zakoupený plán je spojen s e-mailovou adresou uvedenou při placení. Chcete-li plán úspěšně používat, zaregistrujte se nebo se přihlaste pomocí stejné e-mailové adresy.",
    "buy_now": "Koupit hned teď",

    "banner_title": "AI čištění fotografií - kolik kreditů chcete",
    "banner_info": "1 kredit = 1 obrázek: Budete stát 1 kredit za zpracování a uložení obrázku větší než 600 × 600 pixelů. ",
    "monthlyPlan_title": "Měsíční plán",
    "monthlyPlan_displayPricePerCredit": "/kredit",
    "monthlyPlan_plan1_credits": "Kredity/mo",
    "monthlyPlan_feature1": "<Span> bez rizika: </span> 30denní záruka zpětného zády k penězům",
    "monthlyPlan_feature2": "<Span> Automatic: </span> Kredity jsou automaticky obnoveny",
    "monthlyPlan_feature3": "<Span> Flexibilní: </span> Downgrade, upgrade nebo zrušit kdykoli",
    "oneTimePurchase_title": "Jednorázový nákup",
    "oneTimePurchase_plan5_credits": "Kredity/život",
    "oneTimePurchase_feature1": "30denní záruka zpětného peněz",
    "oneTimePurchase_feature2": "Trvale platné po nákupu",
    "payment_title": "Můžete si vybrat více metod platby",
    "payment_image_alt": "Platební metody",
    "faq_title": "Často kladené otázky ohledně nákupu kreditů",
    "faq_question1_title": "Co jsou kredity?",
    "faq_question1_info": "Naše služba se měří v jednotce kreditů. ",
    "faq_question2_title": "Mám si vybrat měsíční předplatné nebo jednorázový nákup?",
    "faq_question2_info": "U nepravidelných úkolů obrazu nebo požadavku na občasné použití si můžete vybrat jednorázový nákup, kde si můžete zakoupit správné množství kreditů na základě vašich požadavků na obrázek. ",
    "faq_question3_title": "Co když využívám své kredity?",
    "faq_question3_info": "Předplatné můžete upgradovat nebo pokračovat v nákupu jednorázového plánu nákupu na základě vašich potřeb zpracování fotografií. ",
    "faq_question4_title": "Mohu upgradovat, downgrade nebo zrušit své předplatné?",
    "faq_question4_info": "Ano, můžete. ",
    "whyChoose_title": "Proč zvolit Tipard",
    "whyChoose_reason1_title": "Zabezpečené stahování",
    "whyChoose_reason1_info": "Programy z Tipardu jsou 100% čisté a bezpečné",
    "whyChoose_reason2_title": "Profesionální tech",
    "whyChoose_reason2_info": "Kvalifikovaný tým poskytuje profesionální produkty",
    "whyChoose_reason3_title": "24/7 zákaznická podpora",
    "whyChoose_reason3_info": "Služby pacientových konzultantů po celou dobu",
    "whyChoose_reason4_title": "30denní peníze zpět",
    "whyChoose_reason4_info": "Zaručuje vrácení peněz uživatelům za 30 dní",
    "whyChoose_reason5_title": "1 000 000+ uživatelů",
    "whyChoose_reason5_info": "Používané a důvěryhodné více než 1 milion lidí",
    "whyChoose_reason6_title": "160+ zemí",
    "whyChoose_reason6_info": "Prodáno ve více než 160 zemích a regionech"
}